import React, { Component } from "react"
import styled from "@emotion/styled"
import CloseIcon from "components/_ui/CloseIcon"
import { Link } from "gatsby"

const ButtonContainer = styled("div")`
  width: 100%;
  text-align: right;
  padding-right: 40px;
`
const Button = styled("button")`
  width: auto;
  height: 100px;
  padding: 1em 0;
  margin: 0 auto;
  text-align: center;
  color: #444444;
  background: none;
  border: none;
  z-index: 2;
  position: relative;

  & svg {
    width: 48px;
  }

  & :hover {
    cursor: pointer;
    color: #000000;
  }
`

class ButtonBack extends Component {
  goBack() {
    window.history.back()
  }
  render() {
    return (
      <ButtonContainer>
        <Link to="/work">
          <Button onClick={this.goBack}>
            <CloseIcon />
          </Button>
        </Link>
      </ButtonContainer>
    )
  }
}

export default ButtonBack
